import { create } from 'zustand';

interface AnimationPreferencesState {
  animationsEnabled: boolean;
  toggleAnimations: () => void;
  setAnimationsEnabled: (enabled: boolean) => void;
}

export const useAnimationPreferences = create<AnimationPreferencesState>(set => ({
  animationsEnabled: true,
  toggleAnimations: () => set(state => ({ animationsEnabled: !state.animationsEnabled })),
  setAnimationsEnabled: (enabled: boolean) => set({ animationsEnabled: enabled }),
}));
